import React from "react";
// import { useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
import Navbar from "../../../components/Navbar/Navbar";
import Footer from "../../../components/Footer/Footer";
import "./Partners.scss";
// import { getPartners } from "redux/apiCalls";

const Partners = () => {
    // const dispatch = useDispatch();
    // const partnersRedux = useSelector((state) => state?.partners);
    // let [partners, setPartners] = useState(partnersRedux?.value);
    // let [partners2, setPartners2] = useState(partnersRedux?.value)
    // if (!partners) {
    //   const params = { config: 'loans.hanfincal.com.more' }
    //   const params2 = { config: 'loans.hanfincal.com.more2' }
    //   getPartners(dispatch, params).then(partners => { setPartners(partners.value) })
    //   getPartners(dispatch, params2).then(partners=>{setPartners2(partners.value)})
    // }

    const [partners, setPartners] = React.useState([]);
    React.useEffect(() => {
        fetch("https://api-inhousepartner.goodchoiceyourbest.com/api/partner")
            .then((response) => response.json())
            .then((data) => {
                setPartners(data.data);
            })
            .catch((error) => console.error("Error fetching partners:", error));
    }, []);

    return (
        <div className="credit-authorization-agreement">
            <Navbar />
            <div className="container-privacy">
                <div className="box-privacy">
                    <p className="partner-list">
                        AlumAds, Solution BPO, X1 Info Tech, JG Wentworth, Stop
                        Go Networks, Dot818, Lead Network, Round Sky, Leap
                        Theory, Teapot, ITMEDIA, LeadsMarket, PingLogix, UpAds,
                        Intimate Interactive, Teapot Media, Leadtree Global,
                        Interlincx Media, Freshway Media, Lead Avenue, Affilic
                        Digital, Boomsourcing, Tradition Media Group, Big Step
                        Marketing, Reliable Leads, RevJolt, Complete Home
                        Services, Insurance Guide, National Association of
                        Chiefs of Police, Autistic Children of America, ITP,
                        Infinity One, Quinstreet, Cane Bay, Gulf Coast Leads,
                        Media Blanket, Liftup Capital, UniFi Funding, AAA Auto
                        Title Loans, LLC, CASH 1, LLC (NV), CASH 1 UT, LLC, CASH
                        1 ID, LLC, CASH 1 KS, LLC, CASH 1 MO, LLC, CASH 1 LA,
                        LLC, ArcaMax Publishing,
                        {partners &&
                            Object.keys(partners).map((partnerName, index) => (
                                <span key={index} className="partner-item">
                                    {partnerName}
                                    {index < Object.keys(partners).length - 1 &&
                                        ", "}
                                </span>
                            ))}
                    </p>
                </div>
            </div>

            <Footer desc={false} />
        </div>
    );
};

export default Partners;
